import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import { addParametersToUri } from 'nallian-shared-ui/lib/lib/uri';
import { COMMUNITY_APPS_RESOURCE } from '../../constants';
import apiRoutes from '../../../../app/api/routes';

const CommunityAppsService = ComposedComponent =>
  reduxFetch([
    {
      resource: COMMUNITY_APPS_RESOURCE,
      method: 'get',
      request: (communityId, t) => ({
        url: addParametersToUri(apiRoutes.communityApps(), { communityId }),
        meta: {
          toaster: {
            onErrorMessage: createErrorMessage(t, 'getAppsFailed'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default CommunityAppsService;
